// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckboxSelectAllController from "./checkbox_select_all_controller.js"
application.register("checkbox-select-all", CheckboxSelectAllController)

import ClipboardController from "./clipboard_controller.js"
application.register("clipboard", ClipboardController)

import DynamicSelectController from "./dynamic_select_controller.js"
application.register("dynamic-select", DynamicSelectController)

import MenuController from "./menu_controller.js"
application.register("menu", MenuController)

import PasswordMatchController from "./password_match_controller.js"
application.register("password-match", PasswordMatchController)

import PerPageSelectController from "./per_page_select_controller.js"
application.register("per-page-select", PerPageSelectController)


import SelectController from "./select_controller.js"
application.register("select", SelectController)

import ToastController from "./toast_controller.js"
application.register("toast", ToastController)

import PasswordViewToggleController from "./password_view_toggle_controller.js"
application.register("password-view-toggle-controller", PasswordViewToggleController)
